import { render, staticRenderFns } from "./newRole.vue?vue&type=template&id=f10bf9a4&scoped=true&"
import script from "./newRole.vue?vue&type=script&lang=js&"
export * from "./newRole.vue?vue&type=script&lang=js&"
import style0 from "./newRole.vue?vue&type=style&index=0&id=f10bf9a4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10bf9a4",
  null
  
)

export default component.exports